import { useEffect } from "react";

// VideoPreloader: mounts tiny offscreen <video> elements with preload="auto"
// to force the browser to start buffering specified video URLs while user is on another page.
// Use sparingly: loading many large files will consume bandwidth.
export default function VideoPreloader({ urls = [], staggerMs = 800 }) {
  useEffect(() => {
    if (!urls || urls.length === 0) return;

    const timers = [];

    urls.forEach((u, i) => {
      const delay = i * staggerMs;
      const t = setTimeout(() => {
        try {
          const v = document.createElement("video");
          v.preload = "auto";
          v.muted = true; // muted allows autoplay in many browsers
          v.playsInline = true;
          // tiny offscreen but present in DOM so browser will load it
          v.style.position = "absolute";
          v.style.width = "1px";
          v.style.height = "1px";
          v.style.opacity = "0";
          v.style.pointerEvents = "none";
          v.style.left = "-10000px";
          // Set src and attach to DOM
          v.src = u;
          document.body.appendChild(v);
          // call load() to encourage the fetch
          v.load?.();
          // Do not attempt to keep a reference to avoid memory growth; browser will cache the bytes
          // remove element after some time to keep DOM clean
          setTimeout(() => {
            try {
              v.remove();
            } catch (e) {}
          }, 60_000); // remove after 60s
        } catch (e) {
          // ignore
        }
      }, delay);
      timers.push(t);
    });

    return () => timers.forEach((t) => clearTimeout(t));
  }, [urls, staggerMs]);

  return null;
}
